import React, { Fragment, useCallback, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { save as saveLead } from '../../services/providers/leads';
import logo from '../../assets/images/business/logo.png';
import img1 from '../../assets/images/business/business-owner-Google-Search-1.jpg';
import img2 from '../../assets/images/business/business-owner-Google-Search-2.jpg';
import img3 from '../../assets/images/business/business-owner-Google-Search.jpg';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

function Main({ history }) {
  const data = useRef({}).current;
  const onNext = useCallback(async (e) => {
    e.stopPropagation();
    e.preventDefault();

    await saveLead(data);
    history.push('/plan', { ...data });
  }, [history, data]);

  const onChange = useCallback((e) => {
    data[e.target.name] = e.target.value;
  }, [data]);

  return (
    <Fragment>
      <section>
        <div className="container">
          <div className="row main_row align-items-center">
            <div className="col-md-6">
              <img className="logo" src={logo} alt="logo" />
              <h2 className="page_description">
                Are you a business owner looking for more clients to walk into your store?
              </h2>
              <h1 className="page_title">download the spoddr app now.</h1>

              <form onSubmit={onNext}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <input
                      type="text" name="name" id="form-field-field_4c30d9e"
                      className="form-control" placeholder="Name"
                      required
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <input type="text" name="address" id="form-field-field_499ffc9"
                           className="form-control" placeholder="Address"
                           required
                           onChange={onChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <input type="text" name="store_name" id="form-field-field_4530b45"
                           className="form-control" placeholder="Store Name"
                           required
                           onChange={onChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <input type="number"
                           name="phone_number"
                           id="form-field-field_1477f23"
                           className="form-control"
                           placeholder="Phone number"
                           required
                           onChange={onChange}
                    />
                  </div>
                  <div className="col-12">
                    <button type="submit" className="btn">Download</button>
                  </div>
                </div>
              </form>

            </div>
            <div className="col-md-6">
              <div className="row align-items-end">
                <div className="col-lg-7 col-6 mb-3">
                  <img src={img1} alt="photo" className="photo_one" />
                </div>
                <div className="col-lg-5 col-6 mb-3">
                  <img src={img2} alt="photo" className="photo_two" />
                </div>
                <div className="col-12 text-center mb-3">
                  <img src={img3} alt="photo" className="photo_three" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
}

export default withRouter(Main);



// WEBPACK FOOTER //
// ./src/containers/Business/index.js